import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { ThemeProvider } from '@mui/material/styles';
import './App.css';
import './styles/site.css';
import { AuthProvider } from './contexts/AuthContext';
import LandingPage from './pages/LandingPage';
import LoginPage from './pages/Login';
import UserManagement from './pages/UserManagement';
import AboutPage from './pages/AboutPage';
import ContactPage from './pages/ContactPage';
import TermsOfServicePage from './pages/TermsOfServicePage';
import PrivacyPolicyPage from './pages/PrivacyPolicyPage';
import MFASetup from './pages/MFASetup';
import AuthAction from './pages/AuthAction';
import PrivateRoute from './components/PrivateRoute';
import Footer from './components/Footer';
import theme from './theme';

function App() {
  return (
    <ThemeProvider theme={theme}>
      <AuthProvider>
        <Router>
          <div className="App">
            <div className="App-content">
              <Routes>
                <Route path="/" element={<LandingPage />} />
                <Route path="/login" element={<LoginPage />} />
                <Route
                  path="/mfa-setup"
                  element={
                    <PrivateRoute skipMfaCheck>
                      <MFASetup />
                    </PrivateRoute>
                  }
                />
                <Route
                  path="/user-management"
                  element={
                    <PrivateRoute requiredRoles={["god", "admin"]}>
                      <UserManagement />
                    </PrivateRoute>
                  }
                />
                <Route path="/auth-action" element={<AuthAction />} />
                <Route path="/about" element={<AboutPage />} />
                <Route path="/contact" element={<ContactPage />} />
                <Route path="/terms-of-service" element={<TermsOfServicePage />} />
                <Route path="/privacy" element={<PrivacyPolicyPage />} />
              </Routes>
            </div>
            <Footer />
          </div>
        </Router>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;